import React, { ReactElement } from "react";
import styled from "styled-components";
import Portal from "./portal";

const BLUR_BACKGROUND = "#blurBackground";

interface Props {
    onCloseHandler: () => void;
    id: string; // to ensure multiple open modals don't affect each other (must be unique)
    children: (ReactElement | null)[] | ReactElement;
    className?: string;
}

const Modal: React.FC<Props> = ({
    onCloseHandler,
    id,
    className,
    children,
}) => {
    // element to which the modal will be rendered

    const handleClose = (e: any) => {
        if (e.target.id === BLUR_BACKGROUND + id) {
            onCloseHandler();
        }
    };

    return (
        <Portal>
            <Container className={className}>
                <BlurBackground
                    id={BLUR_BACKGROUND + id}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleClose(e);
                    }}
                />
                <SubContainer onClick={(e) => e.stopPropagation()}>
                    {children}
                </SubContainer>
            </Container>
        </Portal>
    );
};

const Container = styled.div`
    position: fixed;
    z-index: 1;

    top: 0;
    left: 0;

    height: 100%;
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
`;

const SubContainer = styled.div`
    position: absolute;

    display: flex;
    justify-content: center;
    align-items: center;
`;

const BlurBackground = styled.div`
    height: 100%;
    width: 100%;

    opacity: 0.8;
    background: #a0a0a0;
`;

export default Modal;
